var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.darkTheme ? 'bg-dark' : 'bg-light',attrs:{"id":"app"}},[_c('div',{staticClass:"blower"},[_vm._v("👈🏻")]),_c('Navbar'),_c('router-view'),_c('Footer'),_c('Floating')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }